import { Field } from "@/modules/Forms/models/Field";

export class SectionGroupDetailShort {
  id!: string;
  multiple?: boolean;
  additional?: boolean;
}

export class SectionGroupDetail {
  id!: string;
  name!: string;
  icon?: string;
  playbook?: string;
  required?: boolean;
  idRole?: string;
  form?: string;
  state?: string;
  version?: number;
  multiple?: boolean;
  additional?: boolean;
  fields?: Field[];
}
